import { HttpContextToken } from '@angular/common/http';

/** Marks a request whose 403 response is handled by the caller instead of redirecting to the access-denied page. */
export const SKIP_ACCESS_REDIRECT = new HttpContextToken<boolean>(() => false);
